import { Toast as VoltToast } from "@volt_developers/components";
import { toast, ToastOptions } from "react-toastify";

import { ToastVariant, useToast } from "../../hooks/toasts/useToast";

import type { ReactNode } from "react";

export interface ToastProps {
  bodyContent: ReactNode;
  variant: ToastVariant;
  config?: ToastOptions;
}

interface MessageToastProps {
  bodyContent: ReactNode;
  variant: ToastVariant;
  toastProps?: ToastOptions;
}

export default function MessageToast({
  bodyContent,
  variant,
  toastProps,
}: MessageToastProps) {
  const { iconComponent } = useToast(variant);

  return (
    <VoltToast
      data-testid={(toastProps?.toastId as string) ?? "toast"}
      variant={variant}
    >
      <VoltToast.RootWrapper>
        <VoltToast.IconWrapper>{iconComponent}</VoltToast.IconWrapper>
        <VoltToast.ContentWrapper>{bodyContent}</VoltToast.ContentWrapper>
      </VoltToast.RootWrapper>
    </VoltToast>
  );
}

export const showMessageToast = ({ config, ...propsForToast }: ToastProps) => {
  return toast(<MessageToast {...propsForToast} />, config);
};
